import React from 'react';
import { Form, Radio, Button, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const Step8 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(values => {
        next();
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical">
      <Title level={2}>Driver Obligations</Title>
      <Paragraph>
        All drivers driving for Opera Taxis must comply with all obligations under Point to Point regulations.
      </Paragraph>
      <Paragraph>
        Opera Taxis can immediately suspend your Opera Driver ID if obligations are not met and The Point to Point Transport Commissioner can issue penalties for non-compliance.
      </Paragraph>
      <Paragraph>
        Please read each of the below carefully. You must agree to comply with each obligation prior to going to the next step of the application.
      </Paragraph>

      {[
        "All drivers must meet certain safety standards such as holding an unrestricted driver licence for 12months in the preceding two years and meeting medical standards. Safetystandards for drivers are outlined further here.",
        "Drivers must be logged into the Opera Taxis App and SmartMove Go App in the tablet installed in the car whilst on duty/ready for hire.",
        "Taxi drivers must not smoke/vape in their vehicle at any time.",
        "Drivers must not behave in an offensive manner and must not interfere with the comfort or safety of others.",
        "Drivers’blood alcohol concentration must be under 0.02 grams of alcohol per 100 ml of blood.",
        "Drivers must not damage a vehicle or interfere with its equipment and drivers must not drive a vehicle that they know, or ought reasonably to know, is non-compliant with the Regulations.",
        "Drivers cannot prohibit any assistance animals or assistance animals in training from entering the vehicle.",
        "Drivers, or any other person, must not tout or solicit for passengers for the hiring of a vehicle.",
        "In Airport precincts drivers must only pick up or drop off passengers in the designated areas. Drivers must not leave their vehicle unattended unless in a designated holding bay. Drivers must follow the directions of airport security and staff.",
        "Drivers must follow the reasonable directions of the authorised officers of the Point to Point Transport Commissioner, police officers or officers authorised under transport law. Drivers must hand over their drivers licence for inspection if requested to do so by an authorised officer or the police.",
        "Drivers must only accept bookings from authorised booking service providers.",
        "Drivers must comply with directions given by taxi or booking service providers in the course of collecting the levy.",
        "Drivers are only allowed to stop in an area that is not a taxi zone if they are hired or not available for hire, loading or unloading luggage or goods, or picking up and dropping off passengers. If a taxi is hired or vacant a driver cannot stop in a taxi zone.",
        "Taxi drivers must not interfere or permit interference with a taxi’s tracking device, camera, fare calculation device or duress alarm.",
        "The driver of a taxi that is available for hire must accept a hiring immediately when offered. Taxi drivers can only refuse to pick up a passenger if: it would breach the Road Rules 2014, a driver is finishing their shift and the passenger wishes to go to a location not on the way to the driver’s destination, the passenger is travelling to a location outside the taxi’s area of operation, the person is smoking or drinking alcohol and refuses to stop, the person is likely to damage or soil the taxi or other passengers, or cause inconvenience, offend, annoy or interfere with the comfort or safety of other passengers or the driver, one of the passengers is under the age of one year and neither driver nor passengers is carrying an appropriate child restraint, the passenger, on request, cannot pay the fare in the case of a pre-paid fare, the agreed deposit has not been paid.",
        "Taxi drivers must display their identity document clearly.",
        "For a taxi hiring using the meter, the driver must start the fare calculation device (meter) as soon as the taxi is hired and keep the meter running during the hiring. The meter must be stopped once the hiring has ended or if the taxi is delayed because of a fuel shortage or other reason in the driver’s control."
      ].map((text, index) => (
        <Form.Item
          key={index}
          name={`obligation${index + 1}`}
          label={text}
          rules={[{ required: true, message: 'Please agree to this obligation.' }]}
        >
          <Radio.Group>
            <Radio value="agree">Agreed.</Radio>
          </Radio.Group>
        </Form.Item>
      ))}

      <Form.Item>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step8;
